import { ENUM_CONSTANTS } from 'components/shared/enum.constants';
import { Moment } from 'moment';

export type EnumItemClientSideExport = {
  exclude?: boolean;
  order?: number;
};

export type AsyncSelectSettings = {
  take: number;
  callbackUrl: string;
  searchUrl: string;
  amountOfSymbolsForSearchStart: number;
};

export type DynamicDroppdownSetting = {
  remoteUrl?: string;
  isCaching?: true;
};

export type Attributes = {
  enumItemClientSideExport?: EnumItemClientSideExport;
  readOnly?: boolean;
  enumListClientSide?: keyof typeof ENUM_CONSTANTS;
  generalEnumListClient?: string;
  asyncSelectSettings?: AsyncSelectSettings;
  dynamicDroppdownSetting?: DynamicDroppdownSetting;
  disabled?: boolean;
  tableExcludedAction?: Array<string>;
  dateTimeFormat?: {
    dateFormat?: string;
    timeFormat?: string;
  };
  expanded?: boolean;
  localization?: {
    [key: string]: string;
    default: string;
  };
  hint?: {
    [key: string]: string;
    default: string;
    name: string;
  };
  jsonProperty?: {
    propertyName: string;
  };
  maskProperty?: object;
  regexConstraint?: {
    pattern: string;
    errorMessage: string;
  };
  isDisabledForm?: boolean;
  termsAndConditions?: boolean;
  numeric?: {
    min: number;
    step: number;
    max: number;
    placeholder: string | null;
  };
  fileSourceSetting?: {
    availableMimeTypes: Array<string>;
    maxSize: number;
  };
  cssClass?: string;
  order?: number;
};

export type InputsTableValues = Record<string, string | number | boolean>;

export type Option = {
  attributes: Attributes;
  value: Option | null;
  key: number | string | null;
  name: string;
  id: number;
  type: string;
  canBeNull: boolean;
  values: Array<{ key: string; attributes: Attributes; name: string; value: string }>;
  members: Array<Option>;
};

export interface ISelectOption {
  label: string;
  value: string;
}

export type EventTargetValue = string | boolean | InputsTableValues | Array<InputsTableValues> | Moment;

export type EventTarget = {
  target: {
    name: string;
    value: EventTargetValue;
    type?: string;
    checked?: boolean;
    setCustomValidity?: (value: string) => void;
    validity?: ValidityState;
  };
};

export enum INPUT_TABLE_TYPE_FIELD {
  DYNAMIC_DROPDOWN = 'dynamicdropdown',
  ENUM = 'enum',
  DATETIME = 'datetime',
  BOOL = 'bool',
  HTML = 'html',
  DECIMAL = 'decimal',
  EDITABLE_HTML = 'editablehtml',
  FILE_SOURCE = 'filesource',
}
